var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVoStrongIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22040_16212)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.69727 10.3932C1.69727 5.33062 5.80132 1.22656 10.8639 1.22656C15.9265 1.22656 20.0306 5.33062 20.0306 10.3932C20.0306 15.4558 15.9265 19.5599 10.8639 19.5599C5.80132 19.5599 1.69727 15.4558 1.69727 10.3932Z",
    fill: "#5D5FEF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2885 7.0957C15.614 7.42114 15.614 7.94878 15.2885 8.27421L10.1159 13.6909C9.79051 14.0163 9.26287 14.0163 8.93744 13.6909L6.43744 11.1909C6.112 10.8654 6.112 10.3378 6.43744 10.0124C6.76287 9.68693 7.29051 9.68693 7.61595 10.0124L9.52669 11.9231L14.11 7.0957C14.4355 6.77027 14.9631 6.77027 15.2885 7.0957Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22040_16212"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.863281 0.390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoStrongIcon);
export default __webpack_public_path__ + "static/media/VOStrongIcon.4d5a1eec4c762e714ce3efcee2a6637a.svg";
export { ForwardRef as ReactComponent };